interface BillingEngineValidationError {
  property: string;
  constraints: Record<string, string>;
  children: BillingEngineValidationError[];
}

type ValidationErrors = BillingEngineValidationError[];

class BillingEngineServiceError extends Error {
  error: string;
  code: number;
  constructor(params: { error: string; message: string | ValidationErrors }, statusCode = 500) {
    let message: string | undefined;

    if (Array.isArray(params.message)) {
      message = BillingEngineServiceError.parseValidationErrors(params.message);
    } else {
      message = params.message;
    }

    super(message);
    this.error = params.error;
    this.code = statusCode;
  }

  /**
   * Tries to parse API validation errors
   * @param errors Validation errors from the API
   */
  static parseValidationErrors(errors: ValidationErrors) {
    const error = errors[0];
    const allFailedConstrains = Object.keys(error.constraints);

    if (allFailedConstrains.length > 0) {
      return error.constraints[allFailedConstrains[0]];
    }
  }
}

export default BillingEngineServiceError;
